"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RootErrorBoundary_exports = {};
__export(RootErrorBoundary_exports, {
  RootErrorBoundary: () => RootErrorBoundary
});
module.exports = __toCommonJS(RootErrorBoundary_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = __toESM(require("react"), 1);
var import_react_native = require("react-native");
function _assert_this_initialized(self) {
  if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return self;
}
function _call_super(_this, derived, args) {
  derived = _get_prototype_of(derived);
  return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _create_class(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else obj[key] = value;
  return obj;
}
function _get_prototype_of(o) {
  _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_reflect_construct() {
  try {
    var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (_) {
  }
  return (_is_native_reflect_construct = function() {
    return !!result;
  })();
}
function _possible_constructor_return(self, call) {
  if (call && (_type_of(call) === "object" || typeof call === "function")) return call;
  return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
  _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _set_prototype_of(o, p);
}
function _type_of(obj) {
  "@swc/helpers - typeof";
  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var RootErrorBoundary = /* @__PURE__ */ (function(_React_Component) {
  "use strict";
  _inherits(RootErrorBoundary2, _React_Component);
  function RootErrorBoundary2() {
    _class_call_check(this, RootErrorBoundary2);
    var _this;
    _this = _call_super(this, RootErrorBoundary2, arguments), _define_property(_this, "state", {
      hasError: false,
      error: null,
      componentStack: null
    }), _define_property(_this, "handleRetry", function() {
      _this.setState({
        hasError: false,
        error: null,
        componentStack: null
      });
    });
    return _this;
  }
  _create_class(RootErrorBoundary2, [
    {
      key: "componentDidCatch",
      value: function componentDidCatch(error, info) {
        this.setState({
          componentStack: info.componentStack || null
        });
        console.error(`[One] Root error boundary caught error:
${printError(error)}
${info.componentStack}`);
      }
    },
    {
      key: "render",
      value: function render() {
        if (this.state.hasError) {
          var { error } = this.state;
          return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react_native.View, {
            style: {
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#0a0a0f",
              padding: 24
            },
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.View, {
                style: {
                  width: 64,
                  height: 64,
                  backgroundColor: "#ef4444",
                  borderRadius: 32,
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 24
                },
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.Text, {
                  style: {
                    color: "white",
                    fontSize: 32
                  },
                  children: "!"
                })
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.Text, {
                style: {
                  fontSize: 20,
                  fontWeight: "600",
                  color: "#e8e8e8",
                  marginBottom: 8,
                  textAlign: "center"
                },
                children: "Something went wrong"
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react_native.Text, {
                style: {
                  fontSize: 14,
                  color: "#888",
                  textAlign: "center",
                  marginBottom: 24
                },
                children: (error === null || error === void 0 ? void 0 : error.message) || "An unexpected error occurred"
              })
            ]
          });
        }
        return this.props.children;
      }
    }
  ], [
    {
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError(error) {
        return {
          hasError: true,
          error
        };
      }
    }
  ]);
  return RootErrorBoundary2;
})(import_react.default.Component);
function printError(err) {
  return err instanceof Error ? `${err.message}
${err.stack}` : String(err);
}
//# sourceMappingURL=RootErrorBoundary.js.map
